import * as React from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ReactDOM from 'react-dom';
import { Lead } from '../..';
import { EventPopupContent } from '../../../containers/calendar/components/event-popup-content';
import { IBigCalendarEvent } from './big-calendar-component';
import { EventItemDesign } from './custom-week-view';

interface IBigCalendarEventProps {
  event: IBigCalendarEvent;
  currentView: string;
  setCustomerModal: (id: string, eventId: string, leadDetails?: Lead) => void;
  addActivity?:(data:any) => void,  
}
export const BigCalendarEventComponent: React.FunctionComponent<IBigCalendarEventProps> = (
  props
) => {
  const event = props.event;
  const [showTooltip, setShowTooltip] = React.useState(false);

  const closeTooltip = () => {
    const x: any = document.getElementById('eventPopup');
    x.style.display = 'none';
    setShowTooltip(false);
  };

  const openTooltip = () => {
    setShowTooltip(true);
  };
  const ref = React.useRef(null);

  const getTarget = (): any => {
    return ReactDOM.findDOMNode(ref.current);
  };

  return (
    <div
      className={
        'weekend-activity position-relative row ' +
        event.displayDetails.className
      }
      style={{ height: '100%' }}
      onClick={openTooltip}
      ref={ref}
    >
      <EventItemDesign
        currentView={props.currentView}
        event={event}
      ></EventItemDesign>
      <Overlay
        rootClose
        target={getTarget}
        show={showTooltip}
        flip
        placement="right"
        onHide={closeTooltip}
      >
        <Popover id="eventPopup">
          {/* <Popover.Title as="h3">{` ${event.title}`}</Popover.Title> */}
          <Popover.Content>
            <EventPopupContent
              addActivity={props.addActivity}
              event={event}
              onClose={() => {
                closeTooltip();
              }}
              customerId={event.appointment?.customer?._id}
              setCustomerModal={props.setCustomerModal}
            />
          </Popover.Content>
        </Popover>
      </Overlay>
    </div>
  );
};
